import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Input
} from "reactstrap";

import {
  PanelHeader,
  Statistics,
  Button
} from "components";
import Select from "react-select";
import { validateSpanishId } from "spain-id";
import { Link } from "react-router-dom";

import moment from "moment";

class RouletteDashboard extends React.Component {
  constructor(props) {
    super(props);
    /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
    };
    this.onChange = this.onChange.bind(this);
    this.emailChange = this.emailChange.bind(this);
    this.mobileChange = this.mobileChange.bind(this);
    this.validateNumber = this.validateNumber.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.fullnameValidate = this.fullnameValidate.bind(this);
  }
  componentDidMount() {
  }
  validateForm() {
    return (
      this.state.selectedInterest &&
      this.validatePhoneNumber(this.state.mobile) &&
      this.emailValidate(this.state.email) &&
      this.fullnameValidate(this.state.name)
    );
  }
  fullnameValidate(value) {
    let result = false;
    if (value) {
      let chunks = value.split(" ");
      // Comprobamos que haya más de 1 palabra
      if (chunks.length > 1) {
        let subresult = true;
        // Comprobamos que cada palabra tenga más de 1 caracter
        chunks.map(current => {
          subresult = current.length > 1 && subresult;
        });
        result = subresult;
      }
    }
    return result;
  }
  onChange(field, value) {
    let state = this.state;
    state[field] = value;
    this.setState(state);
  }
  emailValidate(email) {
    if (!email) return false;
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRex.test(email);
  }
  emailChange(e) {
    let email = e.target.value;
    this.setState({
      email: email
    });
    if (this.emailValidate(email)) {
      this.setState({
        emailState: " has-success"
      });
    } else {
      this.setState({
        emailState: " has-danger"
      });
    }
    this.onChange("email", e.target.value);
  }
  mobileChange(e) {
    let mobile = e.target.value;
    this.setState({
      mobile: mobile
    });
    if (this.validatePhoneNumber(mobile)) {
      this.setState({
        mobileState: " has-success"
      });
    } else {
      this.setState({
        mobileState: " has-danger"
      });
    }
    this.onChange("mobile", mobile);
  }
  validateNumber(e) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(e)) {
      return true;
    } else {
      return false;
    }
  }
  validatePhoneNumber(phoneNumber) {
    let result = false;
    if (this.validateNumber(phoneNumber)) {
      if (phoneNumber.startsWith("6") || phoneNumber.startsWith("7") || phoneNumber.startsWith("8") || phoneNumber.startsWith("9")) {
        if (phoneNumber.length === 9) {
          result = true;
        }
      }
    }
    return result;
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "movil":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "newPassword":
        if (this.validateNewPassword(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nombre":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "primer_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "segundo_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "email":
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nif":
        var regPassport = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
        var validPassport = regPassport.test(value);
        if (validateSpanishId(value) || validPassport) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "direccion":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "localidad":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "codigo_postal":
        if (value && value > 0 && value.length === 5) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  handleSpinStop() {
    this.setState({
      mustSpin: false,
      resultReady: true
    });
  }
  handleSpinClick() {
    this.setState({
      waitingResult: true
    });
    // console.log("Solicitando resultado");
    this.props.startWheel().then( response => {
      // console.log("Resultado: ", response);
      this.setState({
        waitingResult: false,
        result: response,
        mustSpin: true,
        prizeNumber: response.result
      });
    });
  }
  render() {
    let colSizes = {
      xs: 12,
      md: 6,
      lg: 4
    };
    return (
      <div>
        <PanelHeader
          size="sm"
          content={
            <div>
              {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
            </div>
          }
        />
        <div className="content">
          <Row>
            <Col {...colSizes}>
              <Link to="/ruleta/jugar">
                <Card className="card-stats card-raised" color="white">
                  <CardBody>
                    <Statistics
                      showIcon
                      iconState="primary"
                      icon="business_chart-pie-36"
                      title="Jugar"
                      subtitle="Girar la ruleta"
                    />
                  </CardBody>
                </Card>
              </Link>
            </Col>
            <Col {...colSizes}>
              <Link to="/ruleta/resultados">
                <Card className="card-stats card-raised" color="white">
                  <CardBody>
                    <Statistics
                      showIcon
                      iconState="info"
                      icon="design_bullet-list-67"
                      title="Lista"
                      subtitle="Ver los resultados"
                    />
                  </CardBody>
                </Card>
              </Link>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default RouletteDashboard;



// WEBPACK FOOTER //
// ./src/views/Roulette/RouletteDashboard.jsx